import React, {useCallback, useMemo} from 'react';
import styled from 'styled-components';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const SPACING_SM = '0.75rem';

const StyledAccordion = styled(Accordion)`
    &.taxonomy-dropdowns {
        width: 100%;
    }
`;

const CheckboxWrapper = styled.div`
    margin-left: ${SPACING_SM};
`;

const StyledCheckbox = styled.input`
    margin-right: ${SPACING_SM};
`;

const StyledLabel = styled.label`
    font-size: 0.875rem;
`;

/**
 * @param {Set<string>} selected - Current selected species
 * @param {string} specie - Specie being toggled
 * @param {boolean} isChecked - Whether checkbox is now checked
 * @returns {Set<string>}
 */
const getUpdatedSpeciesSelection = (selected, specie, isChecked) => {
    const updated = new Set(selected);
    if (isChecked) {
        updated.add(specie);
    } else {
        updated.delete(specie);
    }
    return updated;
};

/**
 * @param {{
 *   options: string[],
 *   value: Set<string>,
 *   onChange: (updatedSelection: Set<string>) => void
 * }} props
 * @returns {JSX.Element}
 */
export const SpeciesFilterUI = ({ options, value, onChange }) => {
    const selectedSpecies = useMemo(() => value || new Set(), [value]);

    const handleCheckboxChange = useCallback(
        (specie) => (e) => {
            const updated = getUpdatedSpeciesSelection(
                selectedSpecies,
                specie,
                e.target.checked
            );
            onChange(updated);
        },
        [selectedSpecies, onChange]
    );

    return (
        <StyledAccordion className="taxonomy-dropdowns">
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="species-filter-content"
            >
                <span>Especies</span>
            </AccordionSummary>
            <AccordionDetails>
                {options.map((specie) => (
                    <CheckboxWrapper key={specie} className="form-check">
                        <StyledCheckbox
                            type="checkbox"
                            className="form-check-input"
                            value={specie}
                            checked={selectedSpecies.has(specie)}
                            onChange={handleCheckboxChange(specie)}
                        />
                        <StyledLabel className="form-check-label">
                            <small>{specie}</small>
                        </StyledLabel>
                    </CheckboxWrapper>
                ))}
            </AccordionDetails>
        </StyledAccordion>
    );
};
